import { useEffect, useRef } from 'react';
import { isWeb } from 'shared/src/utils';
import { useGoodsSno } from './useGoodsSno';
import { usePostAffiliateLinksAccessLogs } from '../queries/usePostAffiliateLinksAccessLogs';

export const useAffiliateAccessLog = () => {
  const goodsSno = useGoodsSno();
  const { mutate } = usePostAffiliateLinksAccessLogs();
  const isSent = useRef(false);

  useEffect(() => {
    if (!isWeb || isSent.current) return;

    const params = new URLSearchParams(window.location.search);
    const uid = params.get('uid');

    if (uid) {
      isSent.current = true;

      mutate({
        uid,
        goods_sno: goodsSno,
      });

      params.delete('uid');
      const nextSearch = params.toString();
      const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}`;
      window.history.replaceState(null, '', nextUrl);
    }
  }, [goodsSno, mutate]);
};